<template>
  <div v-if="editor">
    <div class="p-1 editor-menu">
      <MenuButton
        title="Insertar Tabla"
        icon="table-large-plus"
        @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()"
      />
      <MenuButton
        title="Eliminar Tabla"
        icon="table-large-remove"
        @click="editor.chain().focus().deleteTable().run()"
        :disabled="!editor.can().deleteTable()"
      />
      <MenuButton
        title="Agregar Columna Izquierda"
        icon="table-column-plus-before"
        @click="editor.chain().focus().addColumnBefore().run()"
        :disabled="!editor.can().addColumnBefore()"
      />
      <MenuButton
        title="Agregar Columna Derecha"
        icon="table-column-plus-after"
        @click="editor.chain().focus().addColumnAfter().run()"
        :disabled="!editor.can().addColumnAfter()"
      />
      <MenuButton
        title="Eliminar Columna"
        icon="table-column-remove"
        @click="editor.chain().focus().deleteColumn().run()"
        :disabled="!editor.can().deleteColumn()"
      />
      <MenuButton
        title="Agregar Fila Arriba"
        icon="table-row-plus-before"
        @click="editor.chain().focus().addRowBefore().run()"
        :disabled="!editor.can().addRowBefore()"
      />
      <MenuButton
        title="Agregar Fila Abajo"
        icon="table-row-plus-after"
        @click="editor.chain().focus().addRowAfter().run()"
        :disabled="!editor.can().addRowAfter()"
      />
      <MenuButton
        title="Borrar Fila"
        icon="table-row-remove"
        @click="editor.chain().focus().deleteRow().run()"
        :disabled="!editor.can().deleteRow()"
      />
      <MenuButton
        title="Combinar o Separar Columnas"
        icon="table-merge-cells"
        @click="editor.chain().focus().mergeOrSplit().run()"
        :disabled="!editor.can().mergeOrSplit()"
      />
      <MenuButton
        title="Convertir en Encabezado"
        icon="table-border"
        @click="editor.chain().focus().toggleHeaderCell().run()"
        :disabled="!editor.can().toggleHeaderCell()"
      />
    </div>
  </div>
</template>

<script>
import MenuButton from './MenuButton'

export default {
  props: {
    editor: Object
  },
  components: {
    MenuButton
  }
}
</script>

<style scoped>
.editor-menu {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(35px, 1fr));
  grid-column-gap: 10px;
}
</style>
